<template>
  <div class="orderDetail">
    <el-dialog :close-on-click-modal="false" title="发起对话" :visible.sync="showDialog" @close="$emit('update:showPostMeg', false)"
               :showPostMeg="showPostMeg" width="500px">
      <el-form :model="messageInfo" ref="messageInfo" label-width="130px" size="mini">
        <el-form-item label="聊天对象：">{{topicInfo.player_id}}
          <!--<el-input v-model="topicInfo.player_id" disabled></el-input>-->
        </el-form-item>
        <el-form-item label="发送信息：" prop="message" :rules="[{ required: true, message: '发送信息不能为空'}]">
          <el-input type="textarea" :rows="3" v-model="messageInfo.message" placeholder="请输入发送信息..."></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="$emit('update:showPostMeg', false)" size="small">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="postMeg" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {postTopicMessage} from '@/api'
  export default {
    name: "PostMessage",
    data() {
      return {
        showDialog: this.showPostMeg,
        messageInfo: {},
        loading: false
      }
    },
    props: {
      topicInfo: {
        type: Object
      },
      showPostMeg: {
        type: Boolean,
        default:false
      }
    },
    methods: {
      postMeg(){
        this.$refs.messageInfo.validate(valid => {
          if (valid) {
            postTopicMessage(Object.assign(this.messageInfo, {player_id: this.topicInfo.player_id, play_mch_id: this.topicInfo.player_mch.id})).then(res=>{
              if (res.status === 0) {
                this.$message.success('发送成功')
                this.$emit('update:showPostMeg', false)
              }
            })
          }
        })
      }
    },
    watch: {
      showPostMeg() {
        this.showDialog = this.showPostMeg
      }
    }
  }
</script>
